import Api from '../api/Api';
import resolve from  '../util/Configuracao';
import { parse } from 'date-fns';

class VigenciaPorteApi extends Api {
  async consultarVigencias (codPorte) {
    let vigencias = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    try {
      const vigenciasUrl = resolve('urlConsultarVigencias') + codPorte;
      const { data } = await this.fetch(vigenciasUrl);
      data.map(res => {
        const { codVigencia, codPorteAnestesico, valPorte, dtaInicio, dtaFim, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, nomeUsuarioCancelamento } = res;
        if (dtaCancelamento !== null) {
          tipoBotaoCancelamento = 'DESFAZER';
        } else {
          tipoBotaoCancelamento = 'CANCELAR';
        }
        vigencias.push(Object.values({ codVigencia, codPorteAnestesico, valPorte, dtaInicio, dtaFim, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, nomeUsuarioCancelamento, tipoBotaoCancelamento, brancoAcoes }));
      });
      return vigencias || [];
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPortes () {
    try {
      const portesUrl = resolve('urlConsultarPortes');
      const response = await this.fetch(portesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirVigencia (vigencia) {
    try {
      const urlIncluirVigencia = resolve('urlIncluirVigencia');
      const response = await this.fetch(urlIncluirVigencia, 'put', vigencia);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirVigencia (codVigencia) {
    try {
      const urlExcluirVigencia = resolve('urlExcluirVigencia') + codVigencia;
      const response = await this.fetch(urlExcluirVigencia, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarVigencia (vigencia) {
    try {
      const urlAlterarVigencia = resolve('urlAlterarVigencia');
      const response = await this.fetch(urlAlterarVigencia, 'put', vigencia);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async validarVigencia (vigencia, indInclusao) {
    try {
      const urlValidarVigencia = resolve('urlValidarVigencia') + indInclusao;
      const result = await this.fetch(urlValidarVigencia, 'post', vigencia);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async cancelarVigencia (codVigencia, motivoCancelamento) {
    try {
      const urlCancelarVigencia = resolve('urlCancelarVigencia') + codVigencia + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarVigencia, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoVigencia (codVigencia) {
    try {
      const urlDesfazerCancelamentoVigencia = resolve('urlDesfazerCancelamentoVigencia') + codVigencia;
      const response = await this.fetch(urlDesfazerCancelamentoVigencia, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarValorPorte (codPorteAnestesico, dataRealizacao) {
    try {
      const valorPorteUrl = resolve('valorPorteUrl') + codPorteAnestesico + '/' + parse(dataRealizacao);
      const response = await this.fetch(valorPorteUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async teste () {
    try {
      const urlTeste = resolve('urlTeste');
      const result = await this.fetch(urlTeste, 'post');
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }  
}
export default VigenciaPorteApi;
